import DOMPurify from "dompurify";

// Force rel=noopener noreferrer on any anchor that carries a target attribute,
// to prevent reverse tabnabbing, regardless of the caller's own ALLOWED_ATTR/config.
export const sanitizeHtml = (html, config) => {
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.nodeName === "A" && node.hasAttribute("target")) {
      node.setAttribute("rel", "noopener noreferrer");
    }
  });
  const result = DOMPurify.sanitize(html, config);
  DOMPurify.removeHook("afterSanitizeAttributes");
  return result;
};
